import createSmartIntersector from "../../utils/createSmartIntersector";
import * as mediaPool from "./_mediaPool";
import { controlSpacer } from "./utils";

const threadsClass = "text-post-media";
const lazyThreadsClass = "lazy-text-post-media";

function onIntersect(entry) {
    const target = entry.target;

    async function onFreeSlot(resourceID) {
        function releaseThreadsResource(frame) {
            const container = target.closest(".rm-embed-container.rm-loading");

            if (container) {
                container.classList.remove("rm-loading");
                container.classList.add("rm-loaded");

                setTimeout(() => {
                    controlSpacer(frame, container);
                }, 500);
            }

            mediaPool.release(resourceID);
        }

        target.classList.add(threadsClass);
        target.classList.remove(lazyThreadsClass);

        try {
            const { renderThreadsEmbed } = await import("./instagramThreadsEmbedRenderer");

            if (!renderThreadsEmbed(target, releaseThreadsResource)) {
                mediaPool.release(resourceID);
            }
        } catch (error) {
            mediaPool.release(resourceID);
        }
    }
    mediaPool.request(1700).then(onFreeSlot, () => {});
}

function invalidate(element) {
    element.classList.remove(threadsClass);
    element.classList.add(lazyThreadsClass);
}

export default function loadLazyThreads(intersectionObserverProvider) {
    createSmartIntersector(intersectionObserverProvider, {
        onIntersect,
        onAppear: invalidate,
        initialThreshold: 300,
        selector: "blockquote.text-post-media,blockquote.lazy-text-post-media",
    });
}
